module.exports = __webpack_public_path__ + "static/media/section_bg.3c93c7fe.png";